module.exports = __webpack_public_path__ + "static/img/11041A_4_R_20200319_LC.e10a38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11041A_4_R_20200319_LC.png
// module id = 2z6O
// module chunks = 0